import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/data/forward'
const adminUrl = 'licenseKey'
const plural = 'licensekeys'
const single = 'licensekey'

const forward = new ApiCore({
	index: true,
	findOne: true,
	findAll: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

forward.forward = (id, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

export default forward
